<template>
  <div>
    <b-row v-for="type in workloadTypes" :key="type.workloadTypeId">
      <b-col
        class="font-weight-bold workload-type-label"
        sm="2"
        style="white-space: nowrap"
        >{{ type.workloadTypeDefinition.name }}
      </b-col>

      <b-col class="workload-type-percentage" sm="4" style="margin-left: 75px"
        >{{ type.value | percentage }}%
      </b-col>

      <b-col sm="6">
        <b-progress
          :max="100"
          show-value
          :precision="2"
          :variant="type.value <= 1 ? 'primary' : 'warning'"
        >
          <b-progress-bar :value="type.value * 100"></b-progress-bar>
        </b-progress>
      </b-col>
    </b-row>
    <hr />
    <b-row>
      <b-col class="font-weight-bold workload-type-label" sm="2">Total</b-col>
      <b-col class="workload-type-percentage" sm="4"
        >{{ totalPercentage | percentage }}%</b-col
      >
      <b-col sm="6">
        <b-progress :max="100" show-value :precision="2">
          <b-progress-bar
            :value="totalPercentage * 100"
            :variant="
              totalPercentage >= 0.99 && totalPercentage <= 1.01
                ? 'success'
                : totalPercentage < 1
                ? 'danger'
                : 'warning'
            "
          ></b-progress-bar>
        </b-progress>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    totalPercentage: function () {
      var total = 0;
      if (this.workloadTypes) {
        _.forEach(this.workloadTypes, function (workloadType) {
          total += workloadType.value;
        });
      }
      return total;
    },
  },

  props: {
    workloadTypes: {
      required: true,
      type: Array,
      default() {
        return [];
      },
    },
  },
};
</script>
